export function hasDifferentPropertyValue(
  data: object,
  originalData: object
): boolean {
  const dataKeys = Object.keys(data);

  for (const dataKey of dataKeys) {
    if (data[dataKey] !== originalData[dataKey]) {
      return true;
    }
  }

  return false;
}
